import CoreMenuHomePage from 'src/dispensary/core-menu/home';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';

CoreMenuHomePage.layout = CoreMenuLayout;
export default CoreMenuHomePage;
